import { QueryCombinerType } from 'module/api/filter/types';
import { unreachable } from 'module/helpers/unreachable';
import { useTranslate, UseTranslateType } from 'module/hooks/use-translation';
import { FC } from 'react';

export const matchTypeLabelAString = (
  currentRowIndex: number,
  type: QueryCombinerType,
  translate: UseTranslateType,
) => {
  switch (currentRowIndex) {
    case 0:
      return translate('filters.combiner.label.where');
    default:
      switch (type) {
        case QueryCombinerType.Any:
          return translate('filters.combiner.label.or');
        case QueryCombinerType.All:
          return translate('filters.combiner.label.and');
        default:
          return unreachable(type);
      }
  }
};

interface Props {
  currentRowIndex: number;
  type: QueryCombinerType;
}

export const MatchTypeLabel: FC<Props> = ({ currentRowIndex: index, type }) => {
  const translate = useTranslate();

  return <>{matchTypeLabelAString(index, type, translate)}</>;
};
